import React, { Component } from 'react'
import axios from "axios";
import styles from '../css/ShowCustomerV2.module.css';
import { getInformationWithData } from '../services/CABE.js'
import { pricesFormat } from '../functions/pricesFormat.js';
import { DateFormatMAS90 } from '../functions/dateFormat.js';
import { MobileDisp, NumberFormat } from '../functions/generalFunctions';
import { InvoicePDF } from '../components/InvoicePDF.js';
import { InvoicePDF2 } from '../components/InvoicePDF2';
import { InvoiceZebra } from '../components/InvoiceZebra/InvoiceZebra';
import { DownloadInvoicePDF } from '../components/DownloadInvoicePDF';
import { DownloadInvoicePDF2 } from '../components/DownloadInvoicePDF2';
import { AiFillEdit, AiOutlineClose, AiFillPrinter } from "react-icons/ai";
import { FaRegListAlt, FaUserAlt } from "react-icons/fa";
import { getValueCookie } from '../services/cookieService';
import server from "../services/Connection/backEndLink";
import "../css/general-style.css"
import '../css/table-responsive.css'
import LoadingWindow from '../components/LoadingWindow';


// Menu
import { Menu } from "../components/Menu/Menu";


import { MdEdit } from "react-icons/md";
import SmallModal from '../components/SmallModal.js';
import Swal from 'sweetalert2';

export default class ShowCustomer extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        // Customer: null,
        // invoices: [],
        // invoiceProducts: [],
        // shippingAddresses: [],
        // loadInvoice: null,
        // invoiceSelected: null,
        // shippingAddressesModal: false,
        // addShippingAddressModal: false,
        // upsertShippingAddressesModal: false,
        // isCreatingShippingAddress: false,
        // shippingAddressSelected: {id: '', customerNo: '', name: '', shipping_street: '', shipping_city: '', shipping_state: '', shipping_zip: ''},

      showCustomer: false,
      subtitle: "Search or select a customer to view details and invoice history",
      customerName: "Acme Corporation",
      customerList: [],
      search: "",
      showInvoiceModal: false,
      showCustomerModal: false,
      selectedCustomer: null,
      selectedInvoice: {
        InvoiceNo: '',
        InvoiceType: '',
        InvoiceDate: '',
        CustomerNo: '',
        CustomerName: '',
        Comment: '',
        Total: 0,
        totalPrice: 0,
        totalWeight: 0,
        totalQShipped: 0,
        TotalCost: 0,
        items: []
      },
      invoiceList: [],
      customerListFilter: []
    }

    componentDidMount(){
      
      this.getCustomers();
    //     const stored = localStorage.getItem('selectedCustomer');
    //     if (stored) {
    //         const Customer = JSON.parse(stored);
    //         this.setState({ Customer });
    //         // localStorage.removeItem('selectedCustomer');
    //         this.fetchInvoices(Customer.CustomerNo);
    //     }
    }

    formatCurrency = (quantity) => {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'}).format(quantity);
    }

    formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // enero = 0
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
    
    async fetchInvoices(customerNo) {
        const today = new Date();
        let oneMonthAgo = new Date();
        oneMonthAgo.setDate(today.getDate() - 30);
        
        const company = getValueCookie('CompanyId');
        const startDate = this.formatDate(oneMonthAgo)
        const endDate = this.formatDate(today)
        let responseBack
        const url = server.url

        const payload = {
            data: {
                idCompany: Number(company),
                CustomerNo: customerNo,
                StartDate: startDate,
                EndDate: endDate
            }
        }

        const query = "/invoice/history/header/customer"
            await axios.post(`${url}${query}`, payload).then(
                response => {
                    responseBack = response.data.data.slice(0,10)
                }
            ).catch(error => {
                console.log(error)
                responseBack = []
            })
        this.setState({invoices: responseBack})
    }

    async fetchProducts(invoiceNo) {
        const payload = {
            data: {
                idCompany: 3,
                HeaderSeqNo: '000000',
                InvoiceNo: invoiceNo
            }
        }
        const query = "/invoice/history/detail";
        let responseBack = null;

        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                if (response.data.status.code === 1){
                    responseBack = response.data;
                }
            }
        ).catch(error => {
            console.log(error)
        })
        return responseBack.data;
    }

    realLongDetail(selectedInvoice) {
        let cont = 0
        if(!selectedInvoice){
          return
        }
        selectedInvoice.data.forEach(element => {
            if (element.Visible === 1 && element.quantityShipped > 0) {
                cont++
            }
        });
        return cont
    }

    async loadInvoice(invoice) {
        const invoiceProducts = await this.fetchProducts(invoice.InvoiceNo)

        // Add totals
        const totals = invoiceProducts.reduce(
            (acc, item) => {
                // acc.totalCost += item.UnitCost;
                acc.totalWeight += (item.LineWeight * item.QuantityShipped);
                acc.totalQShipped += item.QuantityShipped;
                return acc;
            },{totalWeight: 0, totalQShipped: 0});

        // Product total price
        const invoiceProductsWTotals = invoiceProducts.map(item => ({
            ...item,
            totalCost: item.UnitPrice * item.QuantityShipped
        }));
        const invoiceWithTotals = {
            ...invoice,
            ...totals
        };
        
        const invoiceComplete = this.printDetail(invoiceProductsWTotals)
        this.setState({invoiceSelected: invoice.InvoiceNo, loadInvoice: invoiceWithTotals, invoiceProducts: invoiceComplete})
    }

    printDetail(invoice) {
        // let detail = []
        // const renameKeys = invoice.map(({ ItemCode, ItemCodeDesc, QuantityOrdered, QuantityShipped, ...rest }) => ({
        //     ...rest,
        //     abbreviatedDesc: ItemCodeDesc,
        //     itemCode: ItemCode,
        //     quantityOrdered: QuantityOrdered,
        //     quantityShipped: QuantityShipped
        // }));

        // renameKeys.forEach(element => {
        //     if (element.quantityShipped !== 0) {
        //         detail.push(element)
        //     }
        // });
        // const tamBreak = getValueCookie("CompanyId") === '3' ? 55 : 45
        // const res = detail.length % tamBreak
        // for (let a = 0; a < tamBreak - res; a++) {
        //     const itemJson = {
        //         itemCode: ' ',
        //         abbreviatedDesc: ' ',
        //         upc: ' ',
        //         quantity: ' ',
        //         ShipWeight: ' ',
        //         StandardUnitCost: ' ',
        //         LastTotalUnitCost: ' ',
        //         UnitPrice: ' ',
        //         upc2: ' ',
        //         caseupc: ' ',
        //         BIN: " ",
        //         totalWeight: ' ',
        //         Comment: " ",
        //         unitCost: ' ',
        //         quantityOrdered: ' ',
        //         quantityReceived: ' ',
        //         quantityShipped: ' ',
        //         totalCost: ' ',
        //         totalFreight: ' ',
        //         Visible: ' ',
        //         BatchUnits: ' ',
        //         DiscountUnits: ' ',
        //         SuggestedDiscount: ' '
        //     }
        //     detail.push(itemJson)
        // }
        // return detail
    }

    textTermsCode(num) {
        switch (Number(num)) {
            case 0:
                return 'Pay in Advance'
            case 1:
                return 'FOB Taiwan'
            case 7:
                return 'Net 07 Days'
            case 10:
                return 'Net 10 Days'
            case 15:
                return 'Net 15 Days'
            case 21:
                return 'Net 21 Days'
            case 30:
                return 'Net 30 Days'
            case 45:
                return 'Net 45 Days'
            default:
                return ''
        }
    }
    
    getAllShippingAddress = async() => {
        const customer = this.state.Customer
        let company = getValueCookie('CompanyId')
        let responseBack;
        const payload = {
            data: {
                companyId: Number(company),
                customerNo: customer.CustomerNo
            }
        }

        const query = "/sales/get-shipping-address-for-customer";
        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                responseBack = response.data.data.data
            }
        ).catch(error => {
            console.log(error)
            responseBack = []
        })
        
        // Get all shipping address 
        this.setState({shippingAddresses: responseBack})
    }

    addShippingAddresses = async () => {
        const customer_no = this.state.Customer.CustomerNo;
        const {
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;

         // Validation before update
        if (
            !shipping_name ||
            !shipping_street ||
            !shipping_city ||
            !shipping_state ||
            !shipping_zip
        ) {
            Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Please fill in all fields before updating.',
            confirmButtonText: 'OK',
            });
            return;
        }

        const url = server.url
        let responseBack;
        const payload = {
            data: {
                companyId: getValueCookie('CompanyId'),
                customerNo: customer_no,
                shipping_name,
                shipping_street,
                shipping_city,
                shipping_state,
                shipping_zip,
            }
        };
        let query = "/sales/create-shipping-address-for-customer";

        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data.data
            }
        ).catch(error => {
            console.log(error)
        })
        
        this.updateShippingAddressList(responseBack, payload.data);
        this.setState({isCreatingShippingAddress: false})
        // if (responseBack.status.code === 1) {
        //     // Actualizar cambios en el estado
        //     this.setState({shippingAddresses: [...this.state.shippingAddresses, responseBack]});
        //     // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
        //     this.clearFormInputs()
        //     this.handleModalClose("upsertShippingAddressesModal")
        // } else {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error',
        //         text: 'An error occurred while updating the shipping address. Please try again.',
        //         confirmButtonText: 'OK',
        //     });
        //     console.error("Error updating shipping address:", responseBack.status.message);
        // }
    }
    
    upsertShippingAddress = async () => {
        const {
            id,
            customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;

         // Validation before update
        if (
            !shipping_name ||
            !shipping_street ||
            !shipping_city ||
            !shipping_state ||
            !shipping_zip
        ) {
            Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Please fill in all fields before updating.',
            confirmButtonText: 'OK',
            });
            return;
        }

        const url = server.url
        let responseBack;
        const payload = {
            data: {
            id,
            companyId: getValueCookie('CompanyId'), 
            customerNo: customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip,
            }
        };
        let query = "/sales/update-shipping-address-for-customer";
        await axios.post(`${url}${query}`, payload).then(
            response => {
                responseBack = response.data.data
            }
        ).catch(error => {
            console.log(error)
        })
        this.updateShippingAddressList(responseBack);
        // if (responseBack.status.code === 1) {
        //     // Actualizar cambios en el estado
        //     const shippingAddresses = this.state.shippingAddresses.map(item => {
        //         if (item.id === id) {
        //             return {
        //                 ...item,
        //                 customer_no,
        //                 shipping_name,
        //                 shipping_street,
        //                 shipping_city,
        //                 shipping_state,
        //                 shipping_zip
        //             };
        //         }
        //         return item;
        //     });
        //     // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
        //     this.clearFormInputs()
        //     this.setState({shippingAddresses})
        //     this.handleModalClose("upsertShippingAddressesModal")
        // } else {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error',
        //         text: 'An error occurred while updating the shipping address. Please try again.',
        //         confirmButtonText: 'OK',
        //     });
        //     console.error("Error updating shipping address:", responseBack.status.message);
        // }
    }

    updateShippingAddressList = (responseBack, newAddress = {}) => {
        const {
            id,
            customer_no,
            shipping_name,
            shipping_street,
            shipping_city,
            shipping_state,
            shipping_zip
        } = this.state.shippingAddressSelected;
        const isCreating = this.state.isCreatingShippingAddress;
        let shippingAddresses = {};

        if (responseBack.status.code === 1) {
            if(isCreating) {
                // Actualizar lista con nuevo item
                shippingAddresses = [
                    ...this.state.shippingAddresses,
                    newAddress
                ]
            } else{
                shippingAddresses = this.state.shippingAddresses.map(item => {
                        // Actualizar lista con los cambios de un item ya existente
                        if (item.id === id) {
                            return {
                                ...item,
                                customer_no,
                                shipping_name,
                                shipping_street,
                                shipping_city,
                                shipping_state,
                                shipping_zip
                            };
                        }
                        return item;
                });
            }
            // Limpiar el estado de la dirección seleccionada y actualizar la lista de shipping addresses
            this.clearFormInputs()
            this.setState({shippingAddresses})
            this.handleModalClose("upsertShippingAddressesModal")
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while updating the shipping address. Please try again.',
                confirmButtonText: 'OK',
            });
            console.error("Error updating shipping address:", responseBack.status.message);
        }
    }

    clearFormInputs = () => {
        this.setState({shippingAddressSelected: {id: '', customer_no: '', shipping_name: '', shipping_street: '', shipping_city: '', shipping_state: '', shipping_zip: ''}})
    }

    handleshippingAddressesModal = () => {
        this.getAllShippingAddress()
        this.setState({shippingAddressesModal: true})
    }

    handleAddShippingAddressesModal = () => {
        this.setState({upsertShippingAddressesModal: true, isCreatingShippingAddress: true})
    }
    
    handleUpdateShippingAddress = (item) => {
        this.setState({upsertShippingAddressesModal: true, shippingAddressSelected: {...item}})
    }
    
    handleModalClose = (modal) => {
        this.setState({[modal]: false})
    }


    // Start template 
    loadCustomer = () => {
      const { search } = this.state;
      if (search.trim()) {
        this.selectCustomer(search);
      }
    };

    selectCustomer = (customer) => {
      this.setState({
        selectedCustomer: customer,        
        ShowCustomer: true
      });

      this.getCustomerInvoices(customer.customerNo);
    };

    clearCustomer = () => {
      const { customerList } = this.state;
      const customerListFilter = customerList.slice(0,10);
      const searchCustomerFilter = document.getElementById('searchCustomerFilter');
      this.setState({
        showCustomer: false,
        subtitle: "Search or select a customer to view details and invoice history",
        search: "",
        selectedCustomer: null,
        selectedInvoice: {},
        invoiceList: [],
        customerListFilter
      });
      searchCustomerFilter.value = '';
    };

    openInvoiceModal = async (invoice) => {
      try {
        const { data } = await getInformationWithData('/v2/get-invoice/detail', { InvoiceNo: invoice.InvoiceNo });
    
        // Now you only care if you actually got a list back
        if (data && data.items.length > 0) {
          const invoiceWDetails = {...invoice, ...data,}
          this.setState({
            selectedInvoice: invoiceWDetails,
            showInvoiceModal: true
          });
          console.log("selected invoice", invoiceWDetails) 
        }
        
      } catch (error) {
          // Any status code that wasn't '1' now ends up here automatically
          this.handleError(error);
      }
      
    };
    // End template

    getCustomers = async () => {
      const salesPerson = getValueCookie('TypeUser') === '8' ? '0000' : getValueCookie('SalesPerson');
      const data = {
        SalespersonNo: salesPerson,
        idCompany: Number(getValueCookie('CompanyId')),
        search: ""
      }
      const response = await getInformationWithData('/customer/getListV2', data);
      const customers = response.data;
      // Filter do not overload modal
      const customerListFilter = customers.slice(0,10)
      if (response.status.code === 1 && response.data.length > 0) {
        this.setState({ customerList: customers, customerListFilter });
      } 
    }

    getCustomerInvoices = async (CustomerNo, Start = '', End = '') => {

      if (Start && End) {
        Start = new Date()
        Start.setDate(End.getDate() - 30);
        End = new Date();
      }

      try {
        const { data } = await getInformationWithData('/invoice/history/header/customerV2', { CustomerNo, Start, End });
    
        // Now you only care if you actually got a list back
        if (data && data.length > 0) {
          this.setState({ invoiceList: data });
        }
        
      } catch (error) {
          // Any status code that wasn't '1' now ends up here automatically
          this.handleError(error);
      }
    }

    contains(parameter, word) {
        if (parameter && word) {
            return parameter.toString().toLowerCase().includes(word.toLocaleLowerCase())
        }

    }
    searchCustomer = e => {
      let searchWord = e.target.value;

      if(searchWord){
          let orders = this.state.customerList.filter((c) => {
              if (((
                  this.contains(c.CustomerNo, searchWord)||
                  this.contains(c.name, searchWord)
              ))
              ) {
                  return c
              } else {
                  return null
              }
          });
          this.setState({ customerListFilter: orders });
      }else{
          let customerListFilter = this.state.customerList
          this.setState({customerListFilter})
      }
    }

    searchByDates = async (Customer) => {
      const CustomerNo = Customer.customerNo;
      const Start = document.getElementById('dateStart').value;
      const End = document.getElementById('dateEnd').value;
      
      if(new Date (Start).getTime() > new Date (End).getTime()){
        console.log("start time is after end date")
      }

      try {
        const { data } = await getInformationWithData('/invoice/history/header/customerV2', { CustomerNo, Start, End });
    
        // Now you only care if you actually got a list back
        if (data) {
          this.setState({ invoiceList: data });
        }
        
      } catch (error) {
          // Any status code that wasn't '1' now ends up here automatically
          this.handleError(error);
      }

    }




    render() {
        const {
          showCustomer,
          subtitle,
          customerList,
          customerListFilter,
          selectedInvoice,
          selectedCustomer,
          invoiceList,
          showInvoiceModal
        } = this.state;

        return (
          <div className="container-fluid">
            <Menu Refresh={this.state.Refresh} Father={this} />
            <LoadingWindow ref={this.ModalLoading} />
            {/* Header */}
            <div className={styles.pageHeader}>
              <div className="container">
                <h1 className={styles.pageTitle}>Customer Information</h1>
                <p className={styles.pageSubtitle}>{subtitle}</p>
              </div>
            </div>

            <div className="container">
              {/* EMPTY STATE */}
              {!showCustomer && !selectedCustomer && (
                <div className="row justify-content-center">
                  <div className="col-lg-8">
                    <div className={styles.modernCard}>
                      <div className={styles.cardBodyCustom}>
                        <div className={styles.emptyState}>
                          <div className={styles.emptyIcon}><FaUserAlt /></div>
                          <h2 className={styles.emptyTitle}>Find Your Customer</h2>
                          <p className={styles.emptyText}>
                            Search by name or customer number to get started
                          </p>

                          {/* <div className={styles.searchWrapper}>
                            <input
                              className={styles.searchInput}
                              value={search}
                              onChange={(e) => this.setState({ search: e.target.value })}
                              onKeyDown={(e) => e.key === "Enter" && this.loadCustomer()}
                            />
                            <button className={styles.searchBtn} onClick={this.loadCustomer}>
                              Search
                            </button>
                          </div>

                          <div className={styles.divider}>
                            <span>OR</span>
                          </div> */}

                          {/* <button
                            className={styles.browseBtn}
                            onClick={() => this.setState({ showCustomerModal: true })}
                          > */}
                          <button className={styles.browseBtn} data-bs-toggle="modal" data-bs-target="#browseCustomersModal">
                            <span><FaRegListAlt /></span>
                            <span>Browse All Customers</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* CUSTOMER CONTENT */}
              {selectedCustomer && (
                <div className={`${styles.customerContent} ${styles.active}`}>
                  <div className="row g-4">
                    <div className="col-12">
                      <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                        <div className={styles.customerHeader}>
                          <h1 className={styles.customerName}>{selectedCustomer.name} Level <strong>{selectedCustomer.priceLevel}</strong></h1>
                          <p className={styles.customerNumber}>Customer No <strong>{selectedCustomer.customerNo}</strong></p>
                          <p className={styles.customerNumber}>Sales Person <strong>{selectedCustomer.salespersonNo}</strong></p>
                        </div>

                        <div className={styles.cardBodyCustom}>
                          <div className={styles.infoGrid}>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>Email</span>
                              <span className={styles.infoValue}>{selectedCustomer.emailAddress ? selectedCustomer.emailAddress : 'No Data' }</span>
                            </div>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>Phone</span>
                              <span className={styles.infoValue}>{selectedCustomer.telephoneNo ? selectedCustomer.telephoneNo : 'No Data' }</span>
                            </div>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>Address</span>
                              <span className={styles.infoValue}>{selectedCustomer.addressLine1}</span>
                            </div>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>City, State ZIP</span>
                              <span className={styles.infoValue}>{`${selectedCustomer.city} ${selectedCustomer.state} ${selectedCustomer.zipCode}`}</span>
                            </div>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>Route</span>
                              <span className={styles.infoValue}>{selectedCustomer.udf_ruta ? selectedCustomer.udf_ruta : 'No Data' }</span>
                            </div>
                            <div className={styles.infoItem}>
                              <span className={styles.infoLabel}>Terms Code</span>
                              <span className={styles.infoValue}>{selectedCustomer.taxSchedule}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* INVOICES */}
                    <div className="col-12">
                      <div className={`${styles.modernCard} ${styles.fadeIn}`}>
                        <div className={styles.cardHeaderCustom}>
                          <div className="d-flex align-items-center">
                              <div className='col-6 justify-content-start'>
                                <h3 className={styles.cardTitle}>Recent Invoices</h3>
                              </div>
                              <div className='col-6 justify-content-end'>
                                <label htmlFor="dateStart"><strong>Start</strong></label>
                                <input type="date" placeholder="Start" id="dateStart" className={styles.dateInput} />
                                <label htmlFor="dateEnd"><strong>End</strong></label>
                                <input type="date" placeholder="End" id="dateEnd" className={styles.dateInput} />
                                <button className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`} style={{padding: '0.5rem 1rem', fontSize: '0.875rem'}} onClick={() => this.searchByDates(selectedCustomer)}>
                                  Search
                                </button>
                              </div>
                          </div>
                        </div>
                        <div className={styles.cardBodyCustom}>
                          <div className={styles.invoiceList}>
                            {invoiceList.map((inv) => (
                              <div
                                key={inv.InvoiceNo}
                                className={styles.invoiceItem}
                                onClick={() => this.openInvoiceModal(inv)}
                                data-bs-toggle="modal" 
                                data-bs-target="#invoiceModal"
                              >
                                <div className={styles.invoiceMain}>
                                  <div className={styles.invoiceNumber}>{inv.InvoiceNo}</div>
                                  <div className={styles.invoiceDate}>{`${this.formatDate(new Date(inv.InvoiceDate))} • ${inv.Comment}`}</div>
                                </div>
                                <div className={styles.invoiceAmount}>{this.formatCurrency(inv.Total)}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* QUICK ACTIONS */}
                    <div className='col-12'>
                      <div className={`${styles.modernCard} ${styles.fadeIn}`} style={{animationDelay: '0.3s'}}>
                        <div className={styles.cardHeaderCustom}>
                          <h3 className={styles.cardTitle}>Quick Actions</h3>
                        </div>
                        <div className={styles.cardBodyCustom}>
                          <div className='row g-3 d-flex justify-content-center'>
                            <div className='col-md-3'>
                              <button className={`${styles.actionBtn} ${styles.btnPrimaryCustom} justify-content-center`} style={{width: '100%'}}>
                                <span><AiFillEdit /> Edit Customer</span>
                              </button>
                            </div>
                            <div className='col-md-3'>
                              <button className={`${styles.actionBtn} ${styles.btnSecondaryCustom} justify-content-center`} style={{width: '100%'}} onClick={() => this.clearCustomer()}>
                                <span><AiOutlineClose /> Clear and Search</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* INVOICE MODAL */}
            {selectedInvoice && selectedCustomer && (
              <div className="modal" id="invoiceModal">
                <div className="modal-dialog modal-xl">
                  <div className={`modal-content ${styles.modalContent}`}>
                    <div className={`modal-header ${styles.modalHeader} justify-content-between align-items-start`}>
                      <div>
                        <h5 className={styles.modalTitle}>Invoice {selectedInvoice.InvoiceNo}</h5>
                        <p className={styles.modalSubtitle}>{selectedCustomer.name}</p>
                      </div>
                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                    </div>
                    <div className={`modal-body ${styles.modalBody}`}>
                      {/* <!-- Invoice Info Grid --> */}
                      <div className={styles.modalInfoGrid}>
                          <div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Invoice Date:</span>
                                  <span className={styles.modalInfoValue}>{new Date(selectedInvoice.InvoiceDate).toLocaleString('en-US')}</span>
                              </div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Comment:</span>
                                  <span className={styles.modalInfoValue}>{selectedInvoice.Comment}</span>
                              </div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Sales Person:</span>
                                  <span className={styles.modalInfoValue}>{selectedCustomer.salespersonNo}</span>
                              </div>
                          </div>
                          <div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Invoice Type:</span>
                                  <span className={styles.modalInfoValue}>{selectedInvoice.InvoiceType} units</span>
                              </div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Quantity Shipped:</span>
                                  <span className={styles.modalInfoValue}>{selectedInvoice.totalQShipped} units</span>
                              </div>
                              <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>Weight:</span>
                                  <span className={styles.modalInfoValue}>{selectedInvoice.totalWeight} lbs</span>
                              </div>
                              {/* <div className={styles.modalInfoItem}>
                                  <span className={styles.modalInfoLabel}>PO Number:</span>
                                  <span className={styles.modalInfoValue}>PO-2024-789</span>
                              </div> */}
                          </div>
                      </div>
                      <h6 className={styles.modalTitleSecondary}>Invoice Items</h6>
                      <div className={styles.modalTableBox}>
                        <table className={styles.modalTable}>
                          <thead>
                            <tr>
                              <th>Item Code</th>
                              <th>Description</th>
                              <th>Unit Weight</th>
                              <th>Q. Ordered</th>
                              <th>Q. Shipped</th>
                              <th>Unit Price</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                            <tbody>
                              {selectedInvoice.items && (selectedInvoice.items.map((item) => (
                                <tr key={item.ItemCode}>
                                  <td>{item.ItemCode}</td>
                                  <td>{item.Description}</td>
                                  <td>{item.Weight} lbs</td>
                                  <td>{item.QuantityOrdered}</td>
                                  <td>{item.QuantityShipped}</td>
                                  <td>{this.formatCurrency(item.UnitPrice)}</td>
                                  <td>{this.formatCurrency(item.Total)}</td>
                                </tr>
                              )))}
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="6" className={styles.modalSummaryRow}>Subtotal:</td>
                                <td>{this.formatCurrency(selectedInvoice.totalPrice)}</td>
                              </tr>
                              {/* <tr>
                                <td colSpan="6" className={styles.modalSummaryRow}>Tax (8.5%):</td>
                                <td>$106.25</td>
                              </tr> */}
                              <tr>
                                <td colSpan="6" className={styles.modalTotalLabel}>Total:</td>
                                <td className={styles.modalTotalText}>{this.formatCurrency(selectedInvoice.totalPrice)}</td>
                              </tr>
                            </tfoot>
                        </table>
                      </div>
                    </div>
                    <div className={`modal-footer ${styles.modalFooter}`}>
                      <button className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`} onClick={() => this.setState({ showInvoiceModal: false })} data-bs-dismiss="modal">Close</button>
                      <button disabled type="button"className={`${styles.actionBtn} ${styles.btnPrimaryCustom}`}><AiFillPrinter /> Print Invoice</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* CUSTOMER MODAL */}
            <div className="modal" id="browseCustomersModal">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Browse Customers</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                  </div>
                  <div className={styles.modalBody}>
                    <div className='mb-3'>
                      <input type='text' id="searchCustomerFilter" className={styles.searchInput} placeholder='Filter customers...' style={{margin: 0}} onKeyUp={this.searchCustomer} />
                    </div>
                    {/* TODO customer endpoint map */}
                    <div className='list-group'>
                      {customerList && (
                        customerListFilter.map ((customer) => (
                            <button key={customer.customerNo} className="list-group-item list-group-item-action" data-bs-dismiss="modal" onClick={() => this.selectCustomer(customer)}>
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>{customer.name}</strong><br />
                                  <small className={styles.smallTextSecondary}>{customer.city} | {customer.state}</small>
                                </div>
                                <span className={`${styles.badgeCustom} ${styles.badgeSuccess}`}>{customer.customerNo}</span>
                              </div>
                            </button>
                          )
                        )
                      )}
                    </div>
                    {/* <button onClick={() => this.selectCustomer("Acme Corporation")}>
                      Acme Corporation
                    </button> */}
                    {/* <button onClick={() => this.selectCustomer("Global Tech")}>
                      Global Tech
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
    }
}